import { Injectable } from '@angular/core';
import { HttpClient, HttpParams, HttpHeaders } from '@angular/common/http';
import { map } from 'rxjs/operators';
import { Observable } from 'rxjs';

import { FvmsApiBaseService } from "./fvms.api.base.service";

@Injectable({providedIn: 'root'})
export class FvmsApiDtgReportDangerService extends FvmsApiBaseService {
    constructor(
        public http:HttpClient
    ) {
        super(http);
    }

    getListReportDangerDrive(searchInfo:any,pagingInfo:any):Observable<any>{
        let url = this.getApiBaseUrl() + "/dtg/report/danger";
        url += "/drive/list";

        let header = new HttpHeaders({
            "Content-Type":"application/json"
        });

        // searchInfo = {
        //     companyId:1
        //     ,searchDateFrom:"2019-04-06 00:00:00"
        //     ,searchDateTo:"2019-04-06 23:59:59"
        //     ,dtgRegDtDurationMin:"5"
        // };
        let tmpPostObject = {
            "searchInfo":searchInfo
            ,"pagingInfo":pagingInfo
        };

        //객체가 연결되어 있어서 주입된 객체에 값을 변경하면 ui의 값도 같이 바뀐다
        //때문에 객체를 복사해서 사용
        let tmpData = JSON.parse(JSON.stringify(tmpPostObject));

        let bodyData = JSON.stringify(tmpData);

        return this.http.post<any>(url,bodyData,{ headers : header });
    }

    getListReportDangerDriveHis(searchInfo:any,pagingInfo:any):Observable<any>{
        let url = this.getApiBaseUrl() + "/dtg/report/danger";
        url += "/his/list";

        let header = new HttpHeaders({
            "Content-Type":"application/json"
        });

        // searchInfo = {
        //     companyId:1
        //     ,searchDateFrom:"2019-04-06 00:00:00"
        //     ,searchDateTo:"2019-04-06 23:59:59"
        //     ,dtgRegDtDurationMin:"5"
        // };
        let tmpPostObject = {
            "searchInfo":searchInfo
            ,"pagingInfo":pagingInfo
        };

        //객체가 연결되어 있어서 주입된 객체에 값을 변경하면 ui의 값도 같이 바뀐다
        //때문에 객체를 복사해서 사용
        let tmpData = JSON.parse(JSON.stringify(tmpPostObject));

        let bodyData = JSON.stringify(tmpData);

        return this.http.post<any>(url,bodyData,{ headers : header });
    }
}